import React, { useMemo, useState } from 'react';
import './style.scss';
import { AdminDataValue } from 'shared';
import clsx from 'clsx';
import { AdminDataUnit, NestedAdminDataUnit } from '../../configConverter';
import Switch from '../../../../general/controls/switch';
import TextField from '../../../../general/controls/textField';

interface Props {
  unit: AdminDataUnit;
  setValue: (newValue: AdminDataValue | AdminDataUnit[]) => any;
  simplified: boolean;
}

const AdminDataSectionUnit = ({ unit, setValue, simplified }: Props) => {
  const [expanded, setExpanded] = useState(false);

  const title = useMemo<string>(() => {
    const array = unit.key.split('');
    const result: Array<string> = [];
    array.forEach((symbol) => {
      if (symbol >= 'A' && symbol <= 'Z') {
        result.push(` ${symbol.toLowerCase()}`);
      } else {
        result.push(symbol);
      }
    });
    return result.join('');
  }, [unit.key]);

  const handleChange = <T extends AdminDataUnit>(
    subUnit: T,
    newValue: T extends NestedAdminDataUnit ? AdminDataUnit[] : AdminDataValue
  ) => {
    if (!unit.nested) return;
    const clone = [...unit.value];
    setValue(
      clone.map((sU) => {
        if (sU.key === subUnit.key) {
          return { ...subUnit, value: newValue };
        }
        return sU;
      })
    );
  };

  if (unit.nested) {
    return (
      <div
        className={clsx(
          'admin-data-unit-nested',
          !expanded && !simplified && 'adun-collapsed',
          simplified && 'adun-simplified'
        )}
      >
        <div
          className='adun-header'
          onClick={() => setExpanded((prev) => !prev || simplified)}
        >
          <h4>{title}</h4>
          {!simplified && <h4 className='adunh-arrow'> {'>'} </h4>}
        </div>
        <div className='adun-content'>
          {unit.value.map((subUnit, index) => (
            <AdminDataSectionUnit
              unit={subUnit}
              setValue={(newValue) => handleChange(subUnit, newValue)}
              key={`${unit.key}-${index}`}
              simplified={simplified}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={clsx('admin-data-unit', simplified && 'adu-simplified')}>
      <div
        className={clsx(
          'adu-title',
          unit.value !== unit.initialValue && 'adu-title-modified'
        )}
      >
        {title}
      </div>
      <div className='adu-value-wrapper'>
        <Value value={unit.value} mutable={unit.mutable} setValue={setValue} />
      </div>
    </div>
  );
};

interface ValueProps {
  value: AdminDataValue;
  setValue: (newValue: AdminDataValue) => any;
  mutable: boolean;
}

const Value = ({ value, setValue, mutable }: ValueProps) => {
  if (!mutable) {
    return <>{value.toString()}</>;
  }
  switch (typeof value) {
    case 'string': {
      return <TextField value={value} setValue={setValue} fullWidth />;
    }
    case 'number': {
      return (
        <TextField
          value={value.toString()}
          setValue={(newValue) => setValue(Number(newValue))}
          type='price'
          fullWidth
        />
      );
    }
    case 'boolean': {
      return <Switch value={value} onClick={() => setValue(!value)} />;
    }
    default: {
      return <h5 style={{ color: '#F3933A' }}>INCORRECT VALUE</h5>;
    }
  }
};

export default AdminDataSectionUnit;
